// src/components/sidebar/TheaterSidebar.jsx
import React, { useEffect, useState } from 'react';
import { PieChartOutlined, UserOutlined, AppstoreOutlined, VideoCameraAddOutlined, HistoryOutlined } from '@ant-design/icons';
import { Layout, Menu } from 'antd';
import UserChip from './UserChip';
import { useNavigate, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const siderStyle = {
  height: '100vh',
  background: '#001529',
  position: 'fixed',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  zIndex: 1030,
};

function getItem(label, key, icon) {
  return { key, icon, label };
}

const TheaterSidebar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState('');

  useEffect(() => {
    const n = localStorage.getItem('name') || 'Theater Staff';
    setName(n);
  }, []);

  const items = [
    getItem('My Profile', '/theater', <UserOutlined />),
    getItem('My Shows', '/theater/shows', <VideoCameraAddOutlined />),
    getItem('Completed Shows', '/theater/completed-shows', <HistoryOutlined />),
    // Add more theater-specific items later like:
    // getItem('Today\'s Shows', '/theater/shows', <VideoCameraOutlined />),
    // getItem('Bookings', '/theater/bookings', <MoneyCollectOutlined />),
  ];

  return (
    <Sider
      style={{
        ...siderStyle,
        width: collapsed ? 0 : 250,
        transition: 'width 0.2s',
      }}
      collapsed={collapsed}
      collapsedWidth={0}
      width={250}
    >
      <div
        style={{
          padding: '8px',
          background: '#001529',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <UserChip
          name={name}
          role="Theater Staff"
          avatar=""
          handleCollapse={() => setCollapsed(!collapsed)}
        />
      </div>

      <div
        style={{
          height: 'calc(100vh - 80px)',
          overflowY: 'auto',
          background: '#001529',
        }}
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={items}
          onClick={({ key }) => navigate(key)}
        />
      </div>
    </Sider>
  );
};

export default TheaterSidebar;